import React, { memo, useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ITEMS_TO_DISPLAY_XS } from "../../../helpers/constants";
import SocialShare from "../../common/SocialShare";
import shareIcon from "../../../assets/fonts/share.svg";
import likeIcon from "../../../assets/fonts/like.svg";
import verifiedIcon from "../../../assets/fonts/verfied.svg";
import { Rate } from "antd";
import calendarIcon from "../../../assets/fonts/calendar_icon.svg";
import calendarGraduate from "../../../assets/fonts/calendar_graduate.svg";
import languageIcon from "../../../assets/fonts/language_icon.svg";
import presenceIcon from "../../../assets/fonts/presence_icon.svg";
import arrowRightIcon from "../../../assets/fonts/arrow_right.svg";
import { slugify } from "../../../helpers/utilities";
import { Link } from "react-router-dom";
import { school } from "../../../assets/images";

const ListSearch = ({
  recognizedByState,
  formationName,
  name,
  publicId,
  isPublic,
  partenary,
  flag,
  country,
  trainingDuration,
  city,
  annualBackToSchool,
  teachingMode,
  language,
  note,
  lng,
  lat,
  loading
}) => {
  const noteValue = parseFloat(note);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const shareLink = `https://dev.aceorientation.com/formations/${slugify(name)}`;

  const handleShareModalOpen = () => {
    setIsShareModalOpen(true);
  };

  const handleShareModalClose = () => {
    setIsShareModalOpen(false);
  };


  const handleClick = useCallback((publicId) => {
    console.log(`Item clicked with publicId: ${publicId}`);
  }, []);

  return (
    <>
      <div className="ace_formation_card rounded-xl bg-white relative">
        <div className="flex justify-between items-center px-3 pt-3">
          <div className="w-4/5">
            <h3 className="font-medium text-lg text-ace-dark_green">
              {formationName}
            </h3>
          </div>
          <div className="flex space-x-4">
            <button type="button" onClick={handleShareModalOpen}>
              <img src={shareIcon} alt="share icon" />
            </button>
            <button type="button">
              <img src={likeIcon} alt="like icon" />
            </button>
            <SocialShare opened={isShareModalOpen} onClosed={handleShareModalClose} shareLink={shareLink} />
          </div>
        </div>
        <div className="flex flex-col relative px-3 pb-3">
          <p className="text-ace-dark_gray text-md font-light">Area of study</p>
          <div className="flex justify-start items-center space-x-2 pt-1">
            <div className="flex items-center space-x-2">
              {recognizedByState === 0 && (
                <>
                  <img src={verifiedIcon} alt="verification icon" />
                  <h3 className="text-md text-ace-green font-medium">
                    Reconnu par l'État
                  </h3>
                  <div className="bar h-4 border-r border-ace-gray_4" />
                </>
              )}
            </div>
            <Rate defaultValue={noteValue} allowClear={false} allowHalf />
          </div>
          <div className="flex justify-start items-center space-x-3 mt-1">
            <div className="w-2/5 max-w-2/5">
              <h3 className="font-bold text-xs text-ace-dark_gray">{name}</h3>
            </div>
            <div className="flex justify-start items-center space-x-2">
              <p>{city}</p>
              {city && (
                <div className="rounded-full w-1 h-1 bg-ace-dark_gray" />
              )}
              <p className="whitespace-nowrap">
                <strong>{country}</strong>
              </p>
              <img
                src={flag}
                alt="country flag"
                className="w-8 h-4 object-contain"
              />
            </div>
          </div>
        </div>
        <div className="bg-[#A8CC444D] w-full flex flex-col space-y-4 justify-center p-3 rounded-b-xl">
          <div className="flex justify-around items-center space-x-4">
            <span className="flex flex-col justify-center items-center space-y-1">
              <img src={calendarIcon} alt="calendar Icon" />
              <p className="text-xs">{annualBackToSchool}</p>
            </span>
            {/* adding training duration */}
            <span className="flex flex-col justify-center items-center space-y-1">
              <img src={calendarGraduate} alt="calendar Icon" />
              <p className="text-xs">{trainingDuration}</p>
            </span>
            <span className="flex flex-col justify-center items-center space-y-1">
              <img src={presenceIcon} alt="language Icon" />
              <p className="text-xs">{teachingMode}</p>
            </span>
            <span className="flex flex-col justify-center items-center space-y-1">
              <img src={languageIcon} alt="language Icon" />
              <p className="text-xs">{language}</p>
            </span>
          </div>
          <div className="flex justify-end items-center">
            <Link
              type="button"
              onClick={() => handleClick(publicId)}
              to={{
                pathname: `/etablissements/${slugify(name)}`,
                state: { code: publicId, isPublic: isPublic, name: name }
              }}
              className="px-8 py-2 rounded-full bg-ace-green text-white font-medium flex justify-center items-center space-x-2"
            >
              <p>Lire plus</p>
              <img src={arrowRightIcon} alt="arrow right icon" />
            </Link>
          </div>
        </div>
      </div>
       {/* {
       loading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
       <div className="spinner-border" role="status">
         <span className="sr-only">Loading...</span>
       </div>
     </div>
     } */}
  
    </>
  )
};

ListSearch.propTypes = {
  col: PropTypes.number,
  recognizedByState: PropTypes.bool,
  logo: PropTypes.string,
  name: PropTypes.string,
  publicId: PropTypes.string,
  universityName: PropTypes.string,
  universityFlag: PropTypes.string,
  isPublic: PropTypes.bool,
  partenary: PropTypes.bool,
  country: PropTypes.string,
  annualBackToSchool: PropTypes.string,
  teachingMode: PropTypes.string,
  language: PropTypes.string,
  note: PropTypes.string,
  verifiedStatus: PropTypes.oneOf(["", "Verified"]),
  flag: PropTypes.any,
  city: PropTypes.string,
  formationName: PropTypes.string,
  trainingDuration: PropTypes.string,
  lng: PropTypes.number,
  lat: PropTypes.number,
};

ListSearch.defaultProps = {
  note: 4.5,
  // lng: -47.9292,
  // lat: -15.7801
};

export default ListSearch;